import Service from '@/service/index.js';
import {purchaseProjectStatus} from '@/utils/mixins/purchase-project-status';
import Payment from '@/components/payment/payment.vue';
import { getUnitByGoodsType } from '@/utils/common.js';

export default {
  components: {
    Payment
  },
  mixins: [purchaseProjectStatus],
  props: {
    projectInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      showPayment: false,
      purchaseProjectType: [],
      qualificationReview: [],
      purchaseType: [],
      purchaseStatus: [],
      flag: false // 是否展示上传公告照片按钮
    };
  },
  created() {
    this.flag = this.$route.query.flag;
    const obj = {
      PURCHASE_PROJECT_TYPE: 'purchaseProjectType',
      QUALIFICATION_REVIEW: 'qualificationReview',
      PURCHASE_TYPE: 'purchaseType',
      PURCHASE_STATUS: 'purchaseStatus'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  computed: {
    noticeEndTimeHoursAdd1 () {
      const str = this.projectInfo && this.projectInfo.noticeEndTime;
      console.log(str, 'str');
      if (str) {
        const timeStr = new String(str).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
        return this.formatDate(new Date(new Date(timeStr).getTime() + 3600000 + 8 * 60 * 60 * 1000), 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    }
  },
  methods: {
    getUnitByGoodsType,
    formatDate(date, fmt) {
      let o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      for (let k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
      return fmt;
    },
    popoverContent (code) {
      if (!code) {return;}
      return this.qualificationReview.find(item => item.code === String(code)) && this.qualificationReview.find(item => String(item.code) === String(code)).description;
    },
    getProjectStatusStyle (status) {
      if (status === 43) {
        return 'background: #F7B500';
      } else if (status === 50) {
        return 'background: #004B7C';
      } else if (status === 51) {
        return 'background: #0DCE03';
      } else if (status === 60) {
        return 'background: #FA5741';
      } else if (status === 70) {
        return 'background: #383838';
      }
    },
    // 上传公告照片
    // 上传公告照片
    uploadAnnouncementImage (item) {
      this.$router.push('/person-center/purchase-business/purchase-project/upload-announcement-image?id=' + item.id);
    },
    paymentSuccess () {
      this.$emit('getDetail');
    }
  }
};
